import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SensorMoistureProfileService {
  private profilesByClient = new Map<
    string,
    Observable<Array<{ id: number; name: string }>>
  >();

  constructor(private $shttp: SuperHttpClientProvider) {}

  listProfiles(
    idCliente?: number
  ): Observable<Array<{ id: number; name: string }>> {
    const key = idCliente ? String(idCliente) : 'all';
    if (!this.profilesByClient.has(key)) {
      const url = idCliente
        ? `/admin/moisture-profile?idCliente=${idCliente}`
        : '/admin/moisture-profile';
      const req$ = this.$shttp.default.get(url).pipe(shareReplay(1));
      this.profilesByClient.set(key, req$);
    }
    return this.profilesByClient.get(key) as Observable<
      Array<{ id: number; name: string }>
    >;
  }

  getSensorProfile(sensorId: number) {
    return this.$shttp.default.get(
      `/admin/sensor/${sensorId}/moisture-profile`
    );
  }

  setSensorProfile(sensorId: number, profileId: number | null) {
    return this.$shttp.default.put(
      `/admin/sensor/${sensorId}/moisture-profile`,
      { profileId }
    );
  }
}
